module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h1', {
    staticClass: "toc-title"
  }, [_vm._v("Contents")]), _vm._v(" "), _c('p', {
    staticClass: "toc-fm"
  }, [_c('a', {
    attrs: {
      "href": "#/007_Maps#fm-1"
    }
  }, [_c('em', [_vm._v("List of Maps")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-fm"
  }, [_c('a', {
    attrs: {
      "href": "#/008_Foreword#fm-2"
    }
  }, [_c('em', [_vm._v("Foreword by")]), _vm._v(" Philip Jenkins")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-fm"
  }, [_c('a', {
    attrs: {
      "href": "#/009_Acknowledgments#fm-3"
    }
  }, [_c('em', [_vm._v("Acknowledgments")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-fm1"
  }, [_c('a', {
    attrs: {
      "href": "#/010_Introduction#fm-4"
    }
  }, [_vm._v("Introduction")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-part"
  }, [_c('a', {
    attrs: {
      "href": "#/011_Part01#pt-1"
    }
  }, [_vm._v("P"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ART")]), _vm._v(" O"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("NE")]), _vm._v(" "), _c('br'), _vm._v("C"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ONCEPTUAL")]), _vm._v(" O"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("VERVIEW")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('a', {
    attrs: {
      "href": "#/012_Chapter01#ch-1"
    }
  }, [_vm._v("1. "), _c('span', {
    staticClass: "toc"
  }, [_vm._v("Migration in Human History: A Conceptual Overview")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('a', {
    attrs: {
      "href": "#/012_Chapter01#sec-1"
    }
  }, [_vm._v("Historiographical Challenges: Contexts, Sources, and Models")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('a', {
    attrs: {
      "href": "#/012_Chapter01#sec-2"
    }
  }, [_vm._v("Definitions and Typologies")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('a', {
    attrs: {
      "href": "#/012_Chapter01#sec-3"
    }
  }, [_vm._v("Ancient Empires and Migrant Movement")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('a', {
    attrs: {
      "href": "#/012_Chapter01#sec-4"
    }
  }, [_vm._v("Phoenicians, Assyrians, and Persians")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('a', {
    attrs: {
      "href": "#/012_Chapter01#sec-5"
    }
  }, [_vm._v("Modes of Travel and the Limits of Migration")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/013_Chapter02#ch-2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("2. "), _c('span', {
    staticClass: "toc"
  }, [_vm._v("Migration and the Globalization of Religion: Understanding Conversion")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/013_Chapter02#sec-6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Cross-Cultural Encounters and Religious Conversion")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/013_Chapter02#sec-7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Imperial Power and Religious Expansion")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/013_Chapter02#sec-8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Religious Conversion: Concept, Variations, and Context")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/013_Chapter02#sec-9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Religious Conversion in Historical Perspective")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/014_Chapter03#ch-3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3. "), _c('span', {
    staticClass: "toc"
  }, [_vm._v("Theologizing Migration: From Eden to Exile")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/014_Chapter03#sec-10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Origins of Israel Debate: Much Archeology, Little Chemistry")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/014_Chapter03#sec-11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The City of Babel as a Paradigm of Anti-Migration: “Lest We Be Scattered”")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/014_Chapter03#sec-12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Migration and the Biblical Tradition")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/014_Chapter03#sec-13",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Hebrew Patriarchs, Migration, and the Foundations of Biblical Faith")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/014_Chapter03#sec-14",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Migration and Mission: The Paradox of Election and Universal Inclusion")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/014_Chapter03#sec-15",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Migration and Mission in the New Testament Period")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-part"
  }, [_c('span', {
    attrs: {
      "href": "#/015_Part02#pt-2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("P"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ART")]), _vm._v(" T"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("WO")]), _vm._v(" "), _c('br'), _vm._v("H"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ISTORICAL")]), _vm._v(" A"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("SSESSMENT")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/015a_Chapter04#ch-4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("4. "), _c('span', {
    staticClass: "toc"
  }, [_vm._v("Christianization of the Roman Empire: The Immigrant Factor")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/015a_Chapter04#sec-16",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("An Ordinary Affair")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/015a_Chapter04#sec-17",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Conditions in the Roman Empire")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/015a_Chapter04#sec-18",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Migrant Factor in the Christianization of Empire")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/015a_Chapter04#sec-19",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Constantine Effect")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/016_Chapter05#ch-5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("5. "), _c('span', {
    staticClass: "toc"
  }, [_vm._v("Frontier Flows: The Faith of Captives and the Fruit of Captivity")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/016_Chapter05#sec-20",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Beyond Frontiers")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/016_Chapter05#sec-21",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Christianity among the Goths")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/017_Chapter06#ch-6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("6. "), _c('span', {
    staticClass: "toc"
  }, [_vm._v("Minority Report: From the Church in Persia to the Persian Church")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/017_Chapter06#sec-22",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Eastward Christian Movement beyond Roman Frontiers")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/017_Chapter06#sec-23",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Migration and the Formation of Persian Christianity")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/017_Chapter06#sec-24",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The “People of God” in Persia")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/017_Chapter06#sec-25",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Becoming the Persian Church")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/017_Chapter06#sec-26",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Persian Christianity and the Persian World")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/017_Chapter06#sec-27",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Persian Conversions")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/018_Chapter07#ch-7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("7. "), _c('span', {
    staticClass: "toc"
  }, [_vm._v("Christ and Odin: Migration and Mission in an Age of Violence")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/018_Chapter07#sec-28",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Texts and Contexts")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/018_Chapter07#sec-29",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Missionary Action and Migrant Agency in the Christianization of Europe (500–1000)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/018_Chapter07#sec-30",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Medieval Monarchs: Political Violence and Missionary Vision")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/018_Chapter07#sec-31",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Context of Conversion")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/019_Chapter08#ch-8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("8. "), _c('span', {
    staticClass: "toc"
  }, [_vm._v("To the Ends of the East: The Faith of Merchants")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/019_Chapter08#sec-32",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Eastern Christian Missionaries: A Note")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/019_Chapter08#sec-33",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Faith of Merchants")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/019_Chapter08#sec-34",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Eastward Migration and Nestorian Missions")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/019_Chapter08#sec-35",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("All Roads Lead to Chang’an")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/019_Chapter08#sec-36",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Story of T’ang Christianity")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/019_Chapter08#sec-37",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Imperial Aegis and Christian Mission")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/020_Chapter09#ch-9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("9. "), _c('span', {
    staticClass: "toc"
  }, [_vm._v("Gaining the World: The Interlocking Strands of Migration, Imperial Expansion, and Christian Mission")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/020_Chapter09#sec-38",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Islamic (Umayyad and Abbasid) Empires")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/020_Chapter09#sec-39",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Pilgrimage and Religious Encounter")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/020_Chapter09#sec-40",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Crusades as Migration")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/020_Chapter09#sec-41",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Mongol Empire")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap1"
  }, [_c('span', {
    attrs: {
      "href": "#/021_Chapter10#ch-10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("10. "), _c('span', {
    staticClass: "toc1"
  }, [_vm._v("Beyond Empire")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/021_Chapter10#sec-42",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Empire and Religious Conversion")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/021_Chapter10#sec-43",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Migrant Factor")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-fm1"
  }, [_c('span', {
    attrs: {
      "href": "#/022_Bibliography#bm-1",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("Bibliography")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7ed54f0e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/006_Contents.vue
// module id = 72
// module chunks = 0